import { useState } from "react";
import DepartmentCard from "./DepartmentCard";
import { useDepartmentList } from "../../../hooks/departments/useDepartmentList";
import PropTypes from "prop-types";
import CenteredModal from "../../modals/CenteredModal";
import AddDepartmentForm from "./AddDepartmentForm";
import ComponentLoader from "../../loadings/ComponentLoader";
import BasicSearchHero from "../../heros/BasicSearchHero";

function Department(props) {
  const { hospitalId } = props;
  const [searchTerm, setSearchterm] = useState("");
  const [show, setShow] = useState(false);
  const query = searchTerm ? `name=${searchTerm}` : "";
  const { data: departmentList, isLoading } = useDepartmentList(
    hospitalId,
    query
  );

  const handleShow = () => {
    setShow(true);
  };
  const handelSearchTerm = (search) => {
    setSearchterm(search);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div className="mt-3">
      <BasicSearchHero
        title="All Departments"
        handleSearchterm={handelSearchTerm}
        handleShow={handleShow}
        buttonTitle="Add Department"
      />
      <div className="tab-list">
        {!isLoading ? (
          departmentList.length > 0 ? (
            <div className="row mt-3 mb-5">
              {departmentList?.map((item) => {
                return (
                  <div
                    className="col-md-3 col-sm-6 col-lg-3 col-xl-3"
                    key={item.id}
                  >
                    <DepartmentCard data={item} />
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="no-content-box d-flex flex-column justify-content-center align-items-center py-5">
              <div className="mb-3">
                <i className="fas fa-building text-muted" style={{ fontSize: '48px' }}></i>
              </div>
              <h5 className="text-muted mb-2">No Departments Found</h5>
            </div>
          )
        ) : (
          <ComponentLoader />
        )}
      </div>

      <CenteredModal
        show={show}
        handleClose={handleClose}
        title="Add Department"
      >
        <AddDepartmentForm handleClose={handleClose} />
      </CenteredModal>
    </div>
  );
}

Department.propTypes = {
  hospitalId: PropTypes.node,
};

export default Department;
